<template>
  <div class="footer">
    <div class="w1200">
      <div class="limit">
        <div class="Foot">
          <div class="syd"><a href=" " target="_blank">
            <img src="../../../public/img/事业单位.png"></a>
          </div>
          <div>
            <span>Copyright © 2024-防灾科技学院 ALL Rights Reserved</span> <br>
            <span>地址：河北省三河市燕郊高新区学院街465号 &nbsp;邮编：065201<br></span>
            <span><a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_self">我是备案号</a></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',

};
</script>


<style>
.footer {
  width: 100%;
  height: 144px;

  background-color: #272829;
}

.el-footer {
  padding: 0;
  box-sizing: border-box;
  flex-shrink: 0;
}

.limit{
  width: 100%;
  margin: 0 auto;
  height: auto;
}

.Foot {
  margin: 0 auto;
  padding: 30px 0 0 0;
  width: 460px;
  display: flex; /* 或 display: grid; */

  align-items: center; /* 垂直居中 */
}

.Foot span {
  color: #ffffff;
  line-height: 27px;
  font-size: 14px;
  margin: 0;
  padding: 0;
}

.Foot a {
  color: rgb(255, 255, 255);
  text-decoration: none;
}

.syd {
  width: 80px;
  float: left;
}

.w1200 {
  width: 100%;
  height: auto;
  margin: 0 auto;
  overflow: hidden;
}
</style>
